import { useLocation } from '@reach/router';
import { useMemo } from 'react';

export function useInitialValues<T>(): T | undefined {
	const location = useLocation();

	const { query } = location;

	return useMemo(() => {
		if (query.data) {
			try {
				return JSON.parse(decodeURIComponent(window.atob(query.data)));
			} catch {
				return {};
			}
		}
		return {};
	}, [query.data]);
}
